import React from "react";
//#region types
import { WintSuperkollAPIModelExportItems } from "wint-api-client/dist/types";
import { ExportedFilesStatusTagsProps } from "models/propTypes/exportedFilesPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useExportItemService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ExportItemStatusTags: React.FC<ExportedFilesStatusTagsProps> = (props) => {
  const exportItemsService = useExportItemService();
  const getLabelClass = (status: WintSuperkollAPIModelExportItems.ExportItemState) => {
    switch (status) {
      case WintSuperkollAPIModelExportItems.ExportItemState.Processing:
        return cssExports.blueTag;
      case WintSuperkollAPIModelExportItems.ExportItemState.Done:
        return cssExports.greenTag;
      case WintSuperkollAPIModelExportItems.ExportItemState.Error:
        return cssExports.redTag;

      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[exportItemsService.getStateText(props.status)]} className={getLabelClass(props.status)} />;
};

export default ExportItemStatusTags;
